import styled from 'styled-components';

export const LoaderContainer = styled.div`
    width: 100%;
    height: 100%;
    background: #FFFFFF;
    position: absolute;
    left: 0;
    right: 0;
    text-align: center;
    top: 0;
    justify-content: center;
    align-items: center;
    display: flex;
    flex-flow:column;
    z-index: 999;
`;

export const Paragraph = styled.p`
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 28px;
    color:#454545;    
`;
